module.exports = "/packs/media/images/lightbulb-68c61227b366acd0c1c5bda23101f44a.png";